import * as React from 'react';

import PropTypes from 'prop-types';
import { connect, Dispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { routerShape, locationShape } from 'react-router';

import CenteredContainer from 'components/CenteredContainer';
import LoadingIndicator from 'components/LoadingIndicator';
// @ts-ignore
import RolePicker from 'components/RolePicker';
// @ts-ignore
import View from 'components/View';
import { AddAction as ToastAddAction, showToast, ToastKind } from 'reducers/toasts';
// @ts-ignore
import UserActions from 'user/UserActions';

type Props = {
  showToast: (text: string, kind: ToastKind, options?: any) => ToastAddAction;
};

type State = {
  working: boolean;
};

class SetupRole extends React.Component<Props, State> {
  static contextTypes = {
    router: routerShape,
    location: locationShape,
  };

  state: State = {
    working: false,
  };

  handleRoleSection = (role: string) => {
    this.setState({ working: true });

    UserActions.update({ role }).then(
      () => this.context.router.push(this.context.location?.state?.location ?? '/'),
      (error: Error) => {
        console.debug(error);
        this.setState({ working: false });
        console.error('SetupRole: could not save user role');
        this.props.showToast('An error occured, please try again.', 'error');
      }
    );
  };

  render() {
    return (
      <CenteredContainer full>
        {this.state.working ? (
          <LoadingIndicator align="center" />
        ) : (
          <View>
            <RolePicker onSelect={this.handleRoleSection} />
          </View>
        )}
      </CenteredContainer>
    );
  }
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
  return bindActionCreators({ showToast }, dispatch);
}

export { SetupRole };
export default connect(undefined, mapDispatchToProps)(SetupRole);
